export enum ProductType {
  SIMPLE = 'simple',
  VARIANT = 'variant',
  CUSTOM = 'custom',
}
